import axiosPost from "./axiosPost";

export const MerchantBORegistroGet= async (credentials, merchantId) => {
    const body = {
        service: "MerchantBORegistroGet",
        params: {
            merchantId: merchantId,
        },
    };    
    try {
        
        const response = await axiosPost("Y", body, credentials)
        return response;
    } catch (err) {
        console.error(`Error: ${err}`);
    }
}